/* 
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent, ReactNode} from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import {makeStyles} from '@material-ui/core/styles';
import Done from '@material-ui/icons/Done';
import {dlsAlt, dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export interface DropdownItemProps {
  text: string | ReactNode;
  onClick?: (event: MouseEvent<HTMLLIElement>) => void;
  selected?: boolean;
  fullWidth?: boolean;
  checked?: boolean;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  dropdownItem : {
    padding         : '14px 11px !important',
    minWidth        : '194px',
    fontSize        : '14px',
    lineHeight      : '20px',
    display         : 'flex',
    justifyContent  : 'space-between',
    alignItems      : 'center',
    backgroundColor : (props: DropdownItemProps) => props.selected && dlsColor('paleBlue'),
    '&:hover'       : {
      backgroundColor : dlsAlt('colors', 'paleBlue2')
    },
    [theme.breakpoints.down('sm')] : {
      padding : '14px 34px !important'
    }
  },
  dropdownText : {
    overflow     : 'hidden',
    maxWidth     : (props: DropdownItemProps) => props.fullWidth ? '100%' : '94%',
    whiteSpace   : 'nowrap',
    textOverflow : 'ellipsis'
  },
  dropdownDone : {
    width  : '18px',
    color  : dlsColor('caBlue'),
    margin : '0 5px'
  }
}));

const DropdownItem = ({text, onClick, ...props}: DropdownItemProps) => {
  const classes = useStyles(props);
  return (
    <MenuItem className={classes.dropdownItem} onClick={onClick}>
      <span className={classes.dropdownText}>{text}</span>
      {props?.checked && <Done className={classes.dropdownDone} />}
    </MenuItem>
  );
};

export default DropdownItem;
